export const FEATURES_FETCH_START = 'FEATURES_FETCH_START';
export const FEATURES_FETCH_SUCCESS = 'FEATURES_FETCH_SUCCESS';
export const FEATURES_FETCH_FAIL = 'FEATURES_FETCH_FAIL';

export const FEATURE_IDS = {
  CALENDAR_INTEGRATIONS: 1,
  PERSONALIZE_LINK: 2,
  REMOVE_BRANDING: 3,
  POOLED_AVAILABILITY: 4,
  GROUP_EVENTS: 5,
  AUTOMATED_EVENT_NOTIFICATIONS: 6,
  AUTOMATED_REMINDERS: 7,
  REDIRECT_CUSTOM_PAGES: 8,
  COLLECT_PAYMENTS: 9,
  COUPON_CODES: 10,
  MARKETING_TOOLS: 11,
  UPSELL_CROSS_SELL: 12,
  OCTOLINK_CUSTOMIZATION: 13,
  METRICS_REPORTING: 14,
  ADD_OCTOLINK_WEBSITE: 15,
  GOOGLE_MEET: 16,
  ZOOM: 17,
  MICROSOFT_TEAMS: 18,
  ZAPIER: 20,
  PROMOTIONAL_BANNERS: 21,
  GUESTS: 22,
};

/** Feature names that are visible but not launch-ready (never show as included). */
export const COMING_SOON_FEATURE_NAMES = ["Zapier"];

export const CALENDAR_FEATURE_NAME =
  "Calendar integrations with Google Calendar, Office 365, Outlook";
export const CALENDAR_FEATURE_NAME_LEGACY =
  "Calendar integrations with Google Calendar, Office 365, Outlook and iCloud";

export const isComingSoonFeature = (name) => {
  if (!name) return false;
  const base = String(name).replace(/\s*\(Coming Soon\)\s*$/i, "").trim();
  return COMING_SOON_FEATURE_NAMES.some(
    (n) => base.toLowerCase() === n.toLowerCase()
  );
};

export const comingSoonFeatureLabel = (name) => {
  if (!isComingSoonFeature(name)) return name;
  return "Zapier (Coming Soon)";
};

/** Strip non-launch claims (e.g. iCloud) from feature labels shown to users. */
export const displayFeatureName = (name) => {
  if (!name) return name;
  let label = String(name).replace(/\s+and iCloud/gi, "");
  return comingSoonFeatureLabel(label);
};

export const isCalendarIntegrationFeature = (name) =>
  name === CALENDAR_FEATURE_NAME || name === CALENDAR_FEATURE_NAME_LEGACY;
